import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _values from 'lodash/values';
import _orderBy from 'lodash/orderBy';

import { createSelector } from 'reselect';

import ThemeCollection from './theme-collection';

const _scopedState = state => state.entities.theme;
const _themesById = state => _scopedState(state).byId;

const _orderThemes = ({ themes, order, dir = 'asc' }) => {
  return _orderBy(themes, [theme => theme[order].toLowerCase()], dir);
};

const themes = createSelector(_themesById, themesById => {
  const _themes = _values(themesById);
  return _isEmpty(_themes) ? ThemeCollection.create() : _themes;
});

const themesOrdered = createSelector(
  [themes, (state, order, dir = 'asc') => ({ order, dir })],
  (themes, { order, dir }) => _orderThemes({ themes, order, dir })
);

// WYN-5807
// We frequently clear out the theme common entity when fetching themes. This selector allows us to retain them in cache and only
// return ones that are compatible with the experience format type we want
const themesByFormatType = createSelector([themes, (state, { formatType }) => formatType], (themes, formatType) =>
  _filter(themes, t => t.validForFormatType === formatType)
);

// WYN-5807
// As a consequence of the above formatType selector, we can also add a order selector
const themesOrderedByFormatType = createSelector(
  [themesByFormatType, (state, { order, dir }) => ({ order, dir })],
  (themes, { order, dir }) => _orderThemes({ themes, order, dir })
);

const themeById = (state, id) => _themesById(state)[id] || {};

export default { themes, themeById, themesOrdered, themesByFormatType, themesOrderedByFormatType };
